module.exports = __webpack_public_path__ + "static/media/pmiic_Loader.7d02b50b.gif";